import {RefundableTicketInfoVo} from '../../common/shared/api/nicolas/vo/RefundableTicketInfoVo.interface';
import {RefundableTicketInfo} from '../generated/types';

export function createRefundableTicketInfo({
  expired_event_cash,
  initial_count,
  normal_cash,
  not_refundable_expired_event_cash,
  not_refundable_point,
  not_refundable_vod_cash,
  paid_ticket_count,
  point,
  price,
  qty,
  refund_ticket_count,
  refund_except_event_cash,
  refundable_normal_cash,
  refundable_valid_event_cash,
  remain_count,
  total_paid_cash,
  used_expired_event_cash,
  used_normal_cash,
  used_paid_ticket_price,
  used_point,
  used_valid_event_cash,
  used_vod_cash,
  valid_event_cash,
  vod_cash,
}: RefundableTicketInfoVo): RefundableTicketInfo {
  return {
    expiredEventCash: expired_event_cash,
    initialCount: initial_count,
    normalCash: normal_cash,
    refundTicketCount: refund_ticket_count,
    notRefundableExpiredEventCash: not_refundable_expired_event_cash
      ? -not_refundable_expired_event_cash
      : not_refundable_expired_event_cash,
    notRefundablePoint: not_refundable_point,
    notRefundableVodCash: not_refundable_vod_cash,
    paidTicketCount: paid_ticket_count,
    point,
    price,
    qty,
    refundExceptEventCash: refund_except_event_cash,
    refundableNormalCash: refundable_normal_cash,
    refundableValidEventCash: refundable_valid_event_cash,
    remainCount: remain_count,
    totalPaidCash: total_paid_cash,
    usedExpiredEventCash: used_expired_event_cash,
    usedNormalCash: used_normal_cash,
    usedPaidTicketPrice: used_paid_ticket_price,
    usedPoint: used_point,
    usedValidEventCash: used_valid_event_cash,
    usedVodCash: used_vod_cash,
    validEventCash: valid_event_cash,
    vodCash: vod_cash,
  };
}
